module.exports = __webpack_public_path__ + "fonts/Sarabun-BoldItalic.35859636.ttf";